import React from 'react';
import { Row, Col, Layout, Card, Skeleton } from 'antd';
import BackLink from '../BackLink';
import QuerySearchAutocomplete from './QuerySearchAutocomplete';
import RecentQueries from './RecentQueries';

const { Content } = Layout;

const QueryDetailsSkeleton = ({ uuid, reloadTrigger }) => {
  return (
    <Content className="page">
      <Row gutter={[32, 32]}>
        {/* Mobile Back Link */}
        <Col xs={24} md={0}>
          <BackLink to='/queries/new' preventHistory={true} />
        </Col>
        
        {/* Sidebar: Search + Recent Queries */}
        <Col xs={24} md={8} lg={8}>
          <QuerySearchAutocomplete/>
          <RecentQueries
            activeQueryUuid={uuid}
            reloadTrigger={reloadTrigger}
          />
        </Col>

        {/* Query Details Skeleton */}
        <Col xs={24} md={16} lg={16}>
          <Card>
            <div style={{ padding: '20px' }}>
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default QueryDetailsSkeleton; 